import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ cardSelected: _ctx.isSelected }, "preview"]),
    style: _normalizeStyle({ background: _ctx.selectedHex.color }),
    "aria-hidden": "true",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)))
  }, null, 6))
}